import { Component, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { CreditCardValidator, CreditCard } from 'angular-cc-library';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PaymentsService } from '../../shared/services/payments.service';
import { BookingService } from '../../shared/services/booking.service';
import swal from 'sweetalert2';
import { OrderingService } from '../services/ordering.service';
@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent implements OnInit, OnDestroy {
  @Input()
  paymentAmount: number;
  @Input()
  total: number;
  @Input()
  amountItem: number;
  @Input()
  data: any;
  @Input()
  typePay: string;
  @Input()
  lg: string;
  @Output()
  isProcess;
  @Output()
  status;

  form: FormGroup;
  submitted = false;
  fetching: { [key: string]: any } = {};
  loading = false;
  pay = false;
  authorize_uri = '';
  isAuthorize_uri = false;
  fees: number;
  constructor(
    private formBuilder: FormBuilder,
    private paymentsService: PaymentsService,
    private bookingService: BookingService,
    private orderingService: OrderingService
  ) {
    this.form = this.formBuilder.group({
      creditCard: ['', [CreditCardValidator.validateCCNumber]],
      expDate: ['', [CreditCardValidator.validateExpDate]],
      cvc: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
      nameOnCard: [null, Validators.required],
      paymentAmount: [null, Validators.min(1)],
      postalCode: [null, Validators.required],
      city: [null, Validators.required],
      fees: null,
      total: null
    });
  }

  ngOnInit() {
    // console.log(this.total, this.amountItem);
    this.fees = 25;
    if (this.data.event.eventRef === 'shop-20181021001') {
      this.fees = 15;
    }
    if (this.data.event.type === 'run') {
      this.fees = 15;
    }
    if (this.paymentAmount) {
      this.form.get('paymentAmount').setValue(Number(this.paymentAmount) + this.fees);
    } else {
      this.form.get('paymentAmount').setValue(Number(this.total) + this.amountItem * this.fees);
      this.form.get('total').setValue(Number(this.total));
      this.form.get('fees').setValue(Number(this.amountItem * this.fees));
    }
    this.onChange();
  }

  ngOnDestroy() {
    for (const key in this.fetching) {
      if (this.fetching.hasOwnProperty(key) && this.fetching[key]) {
        this.fetching[key].unsubscribe();
      }
    }
  }

  onChange() {
    // this.fetching['creditCardOnChange'] = this.form
    //   .get('creditCard')
    //   .valueChanges.subscribe(value => {
    //     // console.log(value);
    //     if (value.length > 2) {
    //       // console.log(CreditCard.cardFromNumber(value));
    //     }
    //   });
  }

  onSubmit(form) {
    this.submitted = true;
    this.loading = true;
    // console.log(form.value);
    const number = this.form.value.creditCard.replace(/\s/g, '');
    const tmpDate = this.form.value.expDate.split('/'); // [mm , yy]
    // console.log(number, tmpDate);
    // card: {
    //       //   name: 'JOHN DOE',
    //       //   city: 'Bangkok',
    //       //   postal_code: 10320,
    //       //   number: '4242424242424242',
    //       //   expiration_month: 9,
    //       //   expiration_year: 2020,
    //       //   security_code: 123
    //       // }

    // console.log(data);
    if (this.data.event.type === 'c') {
      this.fetching['bookingPay'] = this.bookingService
        .getById(this.data.id)
        .subscribe((res: any) => {
          this.pay = res.payment.pay;
          if (!this.loading) {
            let tmpText: string;
            if (this.lg === 'th') {
              tmpText = `ระบบได้รับการชำระเงินของท่านแล้ว! โปรดรอการออกบัตร ใช้เวลาอย่างน้อย 1 วัน เมื่อสำเร็จระบบจะส่งอีเมลไปยืนยันท่าน หรือ สามารถตรวจสถานะและออกบัตรได้ด้วยตัวเองที่เมนู " บัตรของฉัน"`;
            } else {
              tmpText = `We had been of your payment! Please wait for tickets. At least 1 day to complete, the system will send an email to confirm you, or you can check and receive the ticket yourself at the menu. "My Tickets"`;
            }
            swal({
              type: 'success',
              title: 'Payment success!',
              text: tmpText
              // showConfirmButton: false,
              // timer: 1000
            });
            this.form.reset();
            this.submitted = false;
            this.isAuthorize_uri = false;
            this.authorize_uri = '';
          }
        });
      const data = {
        card: {
          name: this.form.value.nameOnCard,
          city: this.form.value.city,
          postal_code: this.form.value.postalCode,
          number: number,
          expiration_month: Number(tmpDate[0]),
          expiration_year: Number(tmpDate[1]),
          security_code: Number(this.form.value.cvc.replace(/\s/g, ''))
        },
        ref: {
          bookingId: this.data.id,
          userId: this.data.user.userId,
          paymentAmount: this.form.value.paymentAmount * 100
        }
      };
      this.paymentsService.payBooking(data).subscribe(
        (resp: any) => {
          // console.log(resp);
          if (resp.status) {
            // resp.data.authorize_uri;
            if (resp.data.failure_code === null) {
              if (resp.data.authorize_uri) {
                this.isAuthorize_uri = true;
                this.authorize_uri = resp.data.authorize_uri;
              } else {
              }
            } else {
              swal({
                type: 'error',
                title: 'Error!',
                text: resp.data.failure_message
                // showConfirmButton: false,
                // timer: 1000
              });
            }
            // if (resp.data.authorize_uri) {
            //   this.isAuthorize_uri = true;
            //   this.authorize_uri = resp.data.authorize_uri;
            // }

            // window.open(resp.data.authorize_uri, '_blank');
            // window.open(resp.data.authorize_uri, "_blank");
            // window.location.href.blink = resp.data.authorize_uri;
            this.loading = false;
            this.submitted = false;
          }
        },
        err => {
          console.log(err);
          this.loading = false;
          this.submitted = false;
        }
      );
    } else {
      this.fetching['orderingPay'] = this.orderingService
        .getById(this.data.id)
        .subscribe((res: any) => {
          this.pay = res.payment.pay;
          if (!this.loading) {
            let tmpText: string;
            if (this.lg === 'th') {
              tmpText = `ระบบได้รับการชำระเงินของท่านแล้ว! ท่านสามารถตรวจสถานะได้ด้วยตัวเองที่เมนู " บัตรของฉัน"`;
            } else {
              tmpText = `We had been of your payment! Can check yourself at the menu. "My Tickets"`;
            }
            swal({
              type: 'success',
              title: 'Payment success!',
              text: tmpText
              // showConfirmButton: false,
              // timer: 1000
            });
            this.form.reset();
            this.submitted = false;
            this.isAuthorize_uri = false;
            this.authorize_uri = '';
          }
        });
      const data = {
        card: {
          name: this.form.value.nameOnCard,
          city: this.form.value.city,
          postal_code: this.form.value.postalCode,
          number: number,
          expiration_month: Number(tmpDate[0]),
          expiration_year: Number(tmpDate[1]),
          security_code: Number(this.form.value.cvc.replace(/\s/g, ''))
        },
        ref: {
          orderingId: this.data.id,
          userId: this.data.user.userId,
          paymentAmount: this.form.value.paymentAmount * 100
        }
      };
      this.paymentsService.payOrdering(data).subscribe(
        (resp: any) => {
          if (resp.status) {
            if (resp.data.failure_code === null) {
              if (resp.data.authorize_uri) {
                this.isAuthorize_uri = true;
                this.authorize_uri = resp.data.authorize_uri;
              } else {
              }
            } else {
              swal({
                type: 'error',
                title: 'Error!',
                text: resp.data.failure_message
              });
            }
            this.loading = false;
            this.submitted = false;
          }
        },
        err => {
          console.log(err);
          this.loading = false;
          this.submitted = false;
        }
      );
    }
  }
}
